import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, User, Clock, ArrowRight } from "lucide-react";
import newsData from "./news-data.json";
import "./news.css";
import Footer from "../../../components/footer";
import Navbar from "../../../components/navbar";

function News() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    document.title = "News - Cheda Gaming";
    setNews(newsData);
  }, []);

  const formatDate = (dateString: string): string => {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  return (
    <div className="news-page page-with-navbar-footer">
      <Navbar />
      <div className="news-container">
        {/* Hero Section */}
        <div className="news-hero-section">
          <div className="news-hero-content">
            <h1 className="news-hero-title">Latest News & Updates</h1>
            <p className="news-hero-subtitle">
              Stay updated with the latest tournaments, community highlights,
              and platform features
            </p>
          </div>
        </div>

        {/* News Grid */}
        <div className="news-content">
          <div className="news-grid">
            {news.map((article) => (
              <div key={article.id} className="news-card">
                <div className="news-card-image">
                  <img
                    src={article.image}
                    alt={article.title}
                    onError={(e) => {
                      e.currentTarget.src = "/images/default-news.jpg";
                    }}
                  />
                  <div className="news-card-category">{article.category}</div>
                </div>

                <div className="news-card-content">
                  <div className="news-card-meta">
                    <span className="news-meta-item">
                      <Calendar />
                      {formatDate(article.date)}
                    </span>
                    <span className="news-meta-item">
                      <User />
                      {article.author}
                    </span>
                    <span className="news-meta-item">
                      <Clock />
                      {article.readTime}
                    </span>
                  </div>

                  <h2 className="news-card-title">{article.title}</h2>
                  <p className="news-card-excerpt">{article.excerpt}</p>

                  <Link to={`/news/${article.slug}`} className="news-card-link">
                    Read More
                    <ArrowRight />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer /> {/* Add Footer at the bottom */}
    </div>
  );
}

export default News;
